import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Spinner from '../components/Spinner';
import PropTypes from 'prop-types';

export function requireAuthentication (Component) {
  class AuthenticatedApp extends React.Component {
    static propTypes = {
      isAuthenticated: PropTypes.bool.isRequired,
      isAuthenticating: PropTypes.bool.isRequired,
      location: PropTypes.object.isRequired,
      dispatch: PropTypes.func.isRequired
    };

    componentWillMount () {
      this.checkAuth(this.props.isAuthenticated);
    }

    componentWillReceiveProps (nextProps) {
      this.checkAuth(nextProps.isAuthenticated);
    }

    checkAuth (isAuthenticated) {
      if (!isAuthenticated) {
        let redirectAfterLogin = this.props.location.pathname;
        if (redirectAfterLogin === '/handleLogin') {
          redirectAfterLogin = '/admin';
        }

        this.props.dispatch(push(`/login?next=${redirectAfterLogin}`));
      }
    }

    render () {
      return this.props.isAuthenticated
        ? <Component {...this.props} />
        : <Spinner active />;
    }
  }

  const mapStateToProps = (state) => ({
    token: state.auth.token,
    isAuthenticated: state.auth.isAuthenticated,
    isAuthenticating: state.auth.isAuthenticating
  });

  return connect(mapStateToProps)(AuthenticatedApp);
}
